export default {
  root: {
    '&:before': {
      backgroundColor: null,
    },
  },
};
